const state = {
  /**
   * Текущий пользователь
   */
  user: null,
};

export default state;
